import {
  IPrismaClientRequestRPC,
  IPrismaGetDMMFRPC,
} from "@prisma/studio-common";
import { PCW } from "@prisma/studio-pcw";
import { IServerOptions } from "../StudioServer";

interface PrismaChannelOptions {
  schemaPath: IServerOptions["schemaPath"];
  schemaText: IServerOptions["schemaText"];
  adapter?: IServerOptions["adapter"];
  prismaClient?: IServerOptions["prismaClient"];
  versions?: IServerOptions["versions"];
}

export class PrismaChannel {
  private pcw: PCW;

  constructor(options: PrismaChannelOptions) {
    this.pcw = new PCW(
      options.schemaText,
      options.schemaPath,
      {},
      { ...options.prismaClient },
      options.adapter,
      options.versions
    );
  }

  public respond = async (
    req: IPrismaGetDMMFRPC["request"] | IPrismaClientRequestRPC["request"]
  ): Promise<
    IPrismaGetDMMFRPC["response"] | IPrismaClientRequestRPC["response"]
  > => {
    const res:
      | IPrismaGetDMMFRPC["response"]
      | IPrismaClientRequestRPC["response"] = {
      requestId: req.requestId,
      channel: `-${req.channel}`,
      action: req.action,
      payload: {
        error: null,
        data: null,
      },
    };

    try {
      switch (req.action) {
        case "getDMMF":
          const { dmmf } = await this.pcw.getDMMF();
          res.payload.data = {
            dmmf,
            schemaHash: this.pcw.schemaHash,
          } as IPrismaGetDMMFRPC["response"]["payload"]["data"];
          break;
        case "clientRequest":
          // First check the schema hash to make sure the query being made is made against the correct schema
          if (
            req.payload.data.schemaHash &&
            req.payload.data.schemaHash !== this.pcw.schemaHash
          ) {
            res.payload.error = {
              type: "PrismaClientSchemaDriftedError",
              code: "P500",
              message:
                "The underlying schema has changed. Please reload Studio.",
              stack: "",
            } as IPrismaClientRequestRPC["response"]["payload"]["error"];
          } else {
            res.payload.data = (await this.pcw.request(
              req.payload.data
            )) as IPrismaClientRequestRPC["response"]["payload"]["data"];
          }
          break;
      }
    } catch (e: any) {
      // Convert this Error object into a POJO so it can be transmitted
      res.payload.error = {
        type: e.type,
        code: e.code,
        message: e.message,
        stack: e.message,
      };
    }

    return res;
  };
}
